import React from "react";

const Experience = () => {
  return (
    <div className="w-full min-h-screen flex flex-col items-center px-4 py-8 bg-gray-100 space-y-6">
      {/* Current Position: TestGrid */}
      <div className="max-w-2xl w-full bg-white shadow-lg rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-[#e84949] mb-2">
          Software Development Engineer - I
        </h2>
        <h3 className="text-lg font-semibold text-gray-800 mb-4">
          <span className="text-[#e84949]">TestGrid.io</span> – Surat, Gujarat
          <br />
          <span className="text-sm text-gray-500 italic">Current Position</span>
        </h3>
        <p className="text-[0.95rem] text-gray-800">
          Learn more about my work at{" "}
          <a
            href="https://testgrid.io/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#e84949] underline font-medium"
          >
            TestGrid.io
          </a>
        </p>
      </div>

      {/* Previous Position: Appgenix */}
      <div className="max-w-2xl w-full bg-white shadow-lg rounded-lg border border-gray-200 p-6">
        <h2 className="text-2xl font-bold text-[#e84949] mb-2">
          Frontend Developer
        </h2>
        <h3 className="text-lg font-semibold text-gray-800 mb-4">
          <span className="text-[#e84949]">Appgenix Infotech</span> – Surat,
          Gujarat
          <br />
          <span className="text-sm text-gray-500 italic">
            6 months experience
          </span>
        </h3>
        <ul className="list-disc list-inside text-gray-800 space-y-2 text-[0.95rem]">
          <li>
            Gained hands-on experience in a fast-paced development environment.
          </li>
          <li>
            Worked extensively on <strong>ReactJS</strong> projects and
            contributed to <strong>Next.js</strong> applications.
          </li>
          <li>
            Implemented tools like <strong>TypeScript</strong>,{" "}
            <strong>React Query</strong>, <strong>React Hook Form</strong>,{" "}
            <strong>Yup</strong>, and <strong>Redux Toolkit</strong>.
          </li>
          <li>
            Created responsive UIs using <strong>Tailwind CSS</strong>,{" "}
            <strong>Material UI</strong>, and <strong>Chakra UI</strong>.
          </li>
          <li>
            Collaborated with cross-functional teams to deliver maintainable and
            high-performance frontend solutions.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Experience;
